import {
  hasModuleAccess,
  hasPageAccess,
} from "@/lib/accessPermissions";

import {
  AGENT_RISK,
  defineAgentAction,
} from "@/agent/actionContract";

import {
  buildAgentCatalogContracts,
  enrichAgentActionContract,
} from "@/agent/actionRuntimeContract";

export {
  AGENT_RISK,
} from "@/agent/actionContract";

// ACTA_AGENT_ACTION_REGISTRY_V1
// ACTA_AGENT_ACTION_REGISTRY_CONTRACT_V2

const workflowActions = [
  // ACTA_AGENT_CONTACT_AGENDA_REGISTRY_V3
  {
    id: "contact.search",
    label: "Rechercher un contact",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["rechercher un contact", "chercher un contact", "trouver un contact"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "contact.open",
    label: "Ouvrir une fiche contact",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["ouvrir un contact", "ouvrir la fiche", "ouvre la fiche"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "contact.note.add",
    label: "Ajouter une note",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["ajouter une note", "ajoute une note", "note sur le contact"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "contact.followup.create",
    label: "Créer une relance",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["créer une relance", "rappelle", "relance", "recontacter"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "meeting.create",
    label: "Créer un rendez-vous",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["créer un rendez vous", "planifier un rendez vous", "programmer un rdv", "créer une réunion"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "meeting.update",
    label: "Modifier un rendez-vous",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "agenda" }],
    aliases: ["modifier un rendez vous", "décaler un rendez vous", "replanifier un rendez vous"],
    requiredEntities: ["meeting"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "meeting.outcome",
    label: "Enregistrer le résultat d’un rendez-vous",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "agenda" }],
    aliases: ["résultat du rendez vous", "rendez vous honoré", "rendez vous annulé", "rendez vous non honoré"],
    requiredEntities: ["meeting"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "contact.create",
    label: "Créer un contact",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["créer un contact", "creer un contact", "ajouter un contact", "nouveau contact", "nouvelle fiche contact"],
    requiredEntities: [],
    risk: AGENT_RISK.CONFIRM,
  },
  {
    id: "contact.whatsapp",
    label: "Ouvrir un contact dans WhatsApp",
    kind: "workflow",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["whatsapp", "appelle via whatsapp", "appeler via whatsapp", "ouvre whatsapp", "ouvrir whatsapp"],
    requiredEntities: ["contact"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "document.share",
    label: "Partager un document",
    kind: "workflow",
    features: ["documentsEnabled", "commercialEnabled"],
    access: [
      { module: "documents", page: "documents" },
      { module: "commercial", page: "portfolio" },
    ],
    aliases: ["partage", "partager", "partage document", "partager document"],
    requiredEntities: ["contact", "document"],
    risk: AGENT_RISK.WORKFLOW,
  },

  // ACTA_AGENT_GMAO_PLANNER_V1
  {
    id: "machine.open",
    label: "Ouvrir une machine",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "machines" }],
    aliases: ["ouvrir une machine", "ouvre la machine", "fiche machine"],
    requiredEntities: ["machine"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "intervention.open",
    label: "Ouvrir une intervention",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["ouvrir une intervention", "ouvre l intervention", "voir l intervention", "mon intervention"],
    requiredEntities: ["intervention"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "intervention.create",
    label: "Créer une intervention",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["créer une intervention", "nouvelle intervention", "planifier une intervention"],
    requiredEntities: ["machine"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "intervention.update",
    label: "Modifier une intervention",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["modifier une intervention", "mets à jour l intervention", "replanifier l intervention"],
    requiredEntities: ["intervention"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "intervention.transition",
    label: "Changer le statut d’une intervention",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["démarre l intervention", "commence l intervention", "termine l intervention", "clôture l intervention", "confirme l intervention"],
    requiredEntities: ["intervention"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "intervention.cancel",
    label: "Annuler une intervention",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["annuler l intervention", "annule l intervention"],
    requiredEntities: ["intervention"],
    risk: AGENT_RISK.WORKFLOW,
  },
  {
    id: "intervention.assign",
    label: "Affecter un technicien",
    kind: "workflow",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["affecter un technicien", "assigne le technicien", "attribue l intervention"],
    requiredEntities: ["intervention"],
    risk: AGENT_RISK.WORKFLOW,
  },
];

const RAW_ACTA_AGENT_ACTIONS = [
  {
    id: "navigation.documents",
    label: "Ouvrir les documents",
    kind: "navigation",
    path: "/app/documents",
    features: ["documentsEnabled"],
    access: [{ module: "documents", page: "documents" }],
    aliases: ["documents", "document", "espace documentaire", "fichiers"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.commercial.dashboard",
    label: "Ouvrir l’accueil commercial",
    kind: "navigation",
    path: "/app/commerce/dashboard",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "dashboard" }],
    aliases: ["accueil commercial", "dashboard commercial", "tableau de bord commercial"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.opportunities",
    label: "Ouvrir les affaires",
    kind: "navigation",
    path: "/app/commerce/pipeline",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "pipeline" }],
    aliases: ["affaires", "pipeline", "opportunites", "opportunités"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.quotes",
    label: "Ouvrir les devis",
    kind: "navigation",
    path: "/app/commerce/quotes",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "quotes" }],
    aliases: ["devis", "proposition commerciale", "propositions commerciales"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.agenda",
    label: "Ouvrir l’agenda",
    kind: "navigation",
    path: "/app/commerce/agenda",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "agenda" }],
    aliases: ["agenda", "rdv", "rendez vous", "rendez-vous"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.contacts",
    label: "Ouvrir les contacts",
    kind: "navigation",
    path: "/app/commerce/prospects",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "portfolio" }],
    aliases: ["contacts", "prospects", "clients", "portefeuille", "repertoire", "répertoire"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.stats",
    label: "Ouvrir les statistiques",
    kind: "navigation",
    path: "/app/commerce/stats",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "stats" }],
    aliases: ["statistiques", "stats"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.commercial.map",
    label: "Ouvrir la carte commerciale",
    kind: "navigation",
    path: "/app/commerce/map",
    features: ["commercialEnabled"],
    access: [{ module: "commercial", page: "map" }],
    aliases: ["carte commerciale", "carte clients", "carte prospects"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.dashboard",
    label: "Ouvrir la GMAO",
    kind: "navigation",
    path: "/app/gmao/dashboard",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "dashboard" }],
    aliases: ["gmao", "dashboard gmao", "tableau de bord gmao", "ma journee", "ma journée"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.map",
    label: "Ouvrir la carte GMAO",
    kind: "navigation",
    path: "/app/gmao/map",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "machines" }],
    aliases: ["carte gmao", "carte machines", "carte parc machines"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.sav",
    label: "Ouvrir les tickets SAV",
    kind: "navigation",
    path: "/app/gmao/sav",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "sav" }],
    aliases: ["sav", "ticket sav", "tickets sav"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.interventions",
    label: "Ouvrir les interventions",
    kind: "navigation",
    path: "/app/gmao/interventions",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "interventions" }],
    aliases: ["intervention", "interventions"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.planning",
    label: "Ouvrir le planning",
    kind: "navigation",
    path: "/app/gmao/planning",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "planning" }],
    aliases: ["planning", "planning gmao", "planning techniciens"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.maintenance",
    label: "Ouvrir la maintenance",
    kind: "navigation",
    path: "/app/gmao/maintenance",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "maintenance" }],
    aliases: ["maintenance", "maintenance preventive", "maintenance préventive", "entretien"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.machines",
    label: "Ouvrir le parc machines",
    kind: "navigation",
    path: "/app/gmao/machines",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "machines" }],
    aliases: ["machines", "parc machines", "installations"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.gmao.parts",
    label: "Ouvrir le stock",
    kind: "navigation",
    path: "/app/gmao/parts",
    features: ["gmaoEnabled"],
    access: [{ module: "gmao", page: "parts" }],
    aliases: ["stock", "pieces", "pièces", "stock pieces", "stock pièces"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.users",
    label: "Ouvrir les utilisateurs",
    kind: "navigation",
    path: "/app/users",
    roles: ["admin", "manager", "maintenance_manager"],
    aliases: ["utilisateurs", "équipe", "equipe", "gestion utilisateurs"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.settings",
    label: "Ouvrir les paramètres",
    kind: "navigation",
    path: "/app/settings",
    aliases: ["paramètres", "parametres", "réglages", "reglages"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  {
    id: "navigation.billing",
    label: "Ouvrir l’abonnement",
    kind: "navigation",
    path: "/app/billing",
    roles: ["admin"],
    aliases: ["abonnement", "facturation", "billing"],
    risk: AGENT_RISK.IMMEDIATE,
  },
  ...workflowActions,
];

export const ACTA_AGENT_ACTIONS = RAW_ACTA_AGENT_ACTIONS.map(defineAgentAction);

export function canUseAgentAction(action, user, hasFeature) {
  if (!action || !user || user.role === "saas_admin") return false;
  if ((action.roles || []).length && !(action.roles || []).includes(user.role)) return false;
  if (
    typeof hasFeature === "function"
    && !(action.features || []).every((feature) => hasFeature(feature))
  ) return false;

  return (action.access || []).every(({ module, page }) =>
    page
      ? hasPageAccess(user, module, page)
      : hasModuleAccess(user, module)
  );
}

export function availableAgentActions({ user, hasFeature }) {
  return ACTA_AGENT_ACTIONS.filter((action) =>
    canUseAgentAction(action, user, hasFeature)
  );
}

// ACTA_AGENT_AUTOMATION_TOOLSET_V4
export function availableAgentToolContracts({user,hasFeature}) {
  return availableAgentActions({user,hasFeature}).map(enrichAgentActionContract);
}
export function allAgentCatalogContracts() { return buildAgentCatalogContracts(); }
export { AGENT_EXECUTION_STATUS,createAgentExecutionEngine,executePreparedAgentAction,prepareAgentExecution } from "@/agent/actionExecutionEngine";
export { AGENT_ENTITY_RESOLUTION_STATUS,resolveAgentContact,resolveAgentDocument,resolveAgentEntity } from "@/agent/resolverRegistry";
export { buildAgentPlannerRequest,buildAgentPlannerSchema,buildAgentPlannerSystemPrompt } from "@/agent/llmPlannerSchema";
